import { render, staticRenderFns } from "./RegisterVerify.vue?vue&type=template&id=2a06e703&"
import script from "./RegisterVerify.vue?vue&type=script&lang=ts&"
export * from "./RegisterVerify.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports